import { sub, add } from '@/utils';

// @aigc:start 2024/07/01-10:26
// 计算优惠价格
export function countDiscount(data) {
  let combinationInfo = [];       // 组合优惠
  let totalCouponsAmount = 0;     // 优惠券总金额

  let label = '';
  let hasReducePrice = false;
  let hasCouponPrice = false;
  let hasVipCouponPrice = false;
  let reduceActivityName = '';

  // 统计优组合优惠券
  if (data.recdGoodsIdNames && data.recdGoodsIdNames.length) {
    const recdGoodsIds = data.recdGoodsIds.split(',');
    combinationInfo = data.recdGoodsIdNames.split(',').map((item, index) => {
      return {
        goodsName: item,
        goodsId: recdGoodsIds[index],
        useCouponPrice: index == 0 ? data.recommendSubAmountTotal : 0
      };
    });
  }
  // 统计优惠券
  if (data.couponBySkuList && data.couponBySkuList.length) {
    data.couponBySkuList.filter(item => {
      totalCouponsAmount = add(totalCouponsAmount, item.fullMoneyReduce);
      item.discountPrice = item.fullMoneyReduce;
      return item;
    });

    hasCouponPrice = true;
  }
  data.combinationInfo = combinationInfo;
  data.totalCouponsAmount = totalCouponsAmount;

  // 如果vipCouponList存在，统计会员券价格、id
  if (data.vipCouponList && data.vipCouponList.length) {
    const vipCoupon = data.vipCouponList[0];
    data.vipCouponPrice = vipCoupon.fullMoneyReduce || 0;
    data.vipCouponCode = vipCoupon.discountCouponCode || '';
    hasCouponPrice = true;
    hasVipCouponPrice = true;
  }

  if (data.totalSubAmount > 0) {
    hasReducePrice = true;
    reduceActivityName = data.dbSubList[0]?.activityName;
  }

  // if (hasReducePrice && !hasCouponPrice) {
  //   label = '优惠后';
  // } else if (!hasReducePrice && hasCouponPrice) {
  //   label = '券后';
  // } else if (hasReducePrice && hasCouponPrice) {
  //   label = '到手';
  // }

  // @aigc:start 2024/11/05-15:06
  if (hasCouponPrice || hasVipCouponPrice) {
    // 存在优惠券
    label = '券后价';
    if (hasReducePrice) {
      // 且存在 立减 || 早鸟价 即（优惠券 + 立减）
      label = '优惠价';
    }
  } else if (hasReducePrice) {
    // 存在立减
    label = reduceActivityName || '';
  }
  // @aigc:end 2024/11/05-15:06


  data && (data.discountLabel = label);

  return data;
}

// 计算商品总价、重置优惠数据格式
export function countPrice(goodsDiscountData) {
  let discountPrice = 0;         // 总价
  let discountAfterPrice = 0;    // 优惠后价格
  try {
    const { showActualPrice, totalSubAmount, totalCouponsAmount, vipCouponPrice } = goodsDiscountData;
    // 优惠券 + 立减 + 会员券 金额
    discountPrice = add(totalCouponsAmount, totalSubAmount || 0);
    discountPrice = add(discountPrice, vipCouponPrice || 0);
    // 减去所有立减、优惠券金额
    discountAfterPrice = sub(showActualPrice, discountPrice);
    discountAfterPrice = discountAfterPrice < 0 ? 0 : discountAfterPrice;
  } catch (error) {
  }

  return { discountPrice, discountAfterPrice };
}

// 计算商品优惠价格
export function countGoodsDiscountInfo(goods, skuId) {
  const { couponUse, skuCouponMapping, specilMapping, reduceFlag, reducePrice = 0, reduceActivityName } = goods;
  let discountPrice = 0;      // 优惠价格
  let vipCouponUse = 0;       // 会员券优惠价格
  let showActualPrice = goods.showActualPrice;
  const isSpecil = specilMapping && specilMapping.length && specilMapping[0].key != 'none';

  if (!couponUse && specilMapping) {
    if (!isSpecil) {
      let value = skuCouponMapping ? Object.values(skuCouponMapping)[0] : {};
      discountPrice = value.discountPrice || 0;
      vipCouponUse = value.membershipCoupons && value.membershipCoupons.discount || 0;
      showActualPrice = specilMapping[0].actualPrice;
    } else {

      try {
        let firstSkuObj = specilMapping.find(data => {
          if (skuId && data.skuId == skuId) {
            return data;
          }
          // return data.stockNum > 0 || (data.fakeStockNum == 1 && data.fakeStockValid > 0);
        });
        if (!firstSkuObj) {
          firstSkuObj = specilMapping.find(data => {
            return data.stockNum > 0 || (data.fakeStockNum == 1 && data.fakeStockValid > 0);
          });
        }

        let key = firstSkuObj?.skuId;
        if (skuCouponMapping && key) {
          discountPrice = skuCouponMapping[key].discountPrice || 0;
          vipCouponUse = skuCouponMapping[key].membershipCoupons && skuCouponMapping[key].membershipCoupons.discount || 0;
        }
        showActualPrice = firstSkuObj.actualPrice;
      } catch (error) {
      }
    }
  }

  discountPrice = add(discountPrice, vipCouponUse);
  let useCouponPrice = discountPrice;                 // 优惠券价格

  let hasReducePrice = false;
  let hasCouponPrice = false;
  // 判断是否有立减
  if (reduceFlag && reducePrice > 0) {
    discountPrice = add(useCouponPrice, reducePrice);
    hasReducePrice = true;
  }
  // 判断是否存在优惠券
  if (useCouponPrice > 0) {
    hasCouponPrice = true;
  }
  let discountLabel = '';
  // if (hasReducePrice && !hasCouponPrice) {
  //   discountLabel = '优惠后';
  // } else if (!hasReducePrice && hasCouponPrice) {
  //   discountLabel = '券后';
  // } else if (hasReducePrice && hasCouponPrice) {
  //   discountLabel = '到手';
  // }

  // @aigc:start 2024-10-23-16:38
  /**
   *  - 权益价：售价 - 活动组合，最终展示“权益价：￥{good.price}” （只要有会员卡券直接展示权益价）
   *  - 活动（立减）：售价 - 活动价（（早鸟 立减）），最终展示“{优惠活动名称}￥{good.price}”
   *  - 券后+立减：售价 - 券 - 活动，最终展示“优惠价￥{good.price}”
   *  - 券后：售价 - 可用优惠券（满减或者现金），最终展示“券后￥{good.price}”
   *
   * 有会员使用类型 1-会员价 2-早鸟价 3-优惠价 4-券后价 5-立减价
   * 1.权益价（多个共存 存在会员券取会员价 ）
   * 2.早鸟价（仅存在早鸟价叫早鸟价） 活动立减
   * 3.优惠价 （优惠券+立减，多个共存并且包括早鸟价）
   * 4.券后价 （满减或者现金）
   * 5.立减价（文案读取立减配置，仅存在立减）
   */
  if (hasCouponPrice || vipCouponUse) {
    // 存在优惠券
    discountLabel = '券后价';
    if (hasReducePrice || goods.birdPrice) {
      // 且存在 立减 || 早鸟价 即（优惠券 + 立减）
      discountLabel = '优惠价';
    }
  } else if (goods.birdPrice) {
    // 存在早鸟价
    discountLabel = goods.birdRemark || '';
  } else if (hasReducePrice) {
    // 存在立减
    discountLabel = goods.reduceActivityName || '';
  }
  // @aigc:end 2024-10-23-16:38


  let discountAfterPrice = sub(showActualPrice, discountPrice);
  discountAfterPrice = discountAfterPrice < 0 ? 0 : discountAfterPrice;

  return { useCouponPrice, discountPrice, discountAfterPrice, showActualPrice, discountLabel };
}
// @aigc:end 2024/07/01-10:26
